<body id="body">    

    <!-- view-->
    <div class="router-wrapper" [@fromLeftEasing]="getState(o)">
           <router-outlet #o="outlet"></router-outlet>
    </div>
    <!-- view-->

    <!-- offline layer -->  
    <div class="offline-layer" *ngIf="showOnlineLayer == true">
        <p>{{"connection_problem" | translate}}</p>
        <a>
          <mdb-icon fas icon="redo-alt" (click)="refresh()"></mdb-icon>
        </a>
    </div>
  <!-- offline layer -->

</body>

